import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FeatureFlagService, FeatureFlagStatusInterface } from '@galaxy/partner';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { ApiService } from '../api-service/api.service';

const GET_VCONFIG_URL = '/_ajax/v1/vconfig/get';
const GET_MARKETS_WITH_CONFIGURATION_URL = '/_ajax/v1/vconfig/getMarketIdsWithConfiguration';

export interface FeatureFlagsMap {
  [featureName: string]: boolean;
}

@Injectable({ providedIn: 'root' })
export class VConfigService {
  constructor(
    private _http: HttpClient,
    private apiService: ApiService,
    private featureFlagService: FeatureFlagService,
  ) {}

  getConfigurations(partnerId: string, keys: string[], marketId?: string): Observable<any> {
    let params = new HttpParams().set('partnerId', partnerId);
    keys.forEach((key) => (params = params.append('configurationKeys', key)));
    if (marketId) {
      params = params.set('marketId', marketId);
    }
    return this._http.get<{ data: any }>(GET_VCONFIG_URL, { params }).pipe(
      map((response) => response.data),
      share(),
    );
  }

  getMarketIdsWithConfigurations(partnerId: string, filters: any[]): Observable<any> {
    let params = new HttpParams();
    params = params.set('partnerId', partnerId);
    filters.forEach((filter) => (params = params.set('filtersJson', JSON.stringify(filter))));
    return this.apiService.get(GET_MARKETS_WITH_CONFIGURATION_URL, { params });
  }

  // note: this should not to be confused with `core/access/access.service.ts`
  // this is for individual features configured here https://partners.vendasta.com/superadmin/feature-access/manage?marketId=default
  isFeatureEnabled(featureIds: string[], partnerId: string, marketId: string): Observable<FeatureFlagStatusInterface> {
    return this.featureFlagService.batchGetStatus(partnerId, marketId, featureIds);
  }
}
